import { getBillingManualOtherDeductions } from 'utils/otherDeductionColumns'

/** Mongo often has ObjectId vs string mismatch — must compare as strings. */
function allowanceAppliesToEmployee(allowance, entry) {
    if (!allowance?.user_id || entry?.employee_id == null) return false
    return String(allowance.user_id) === String(entry.employee_id)
}

export function computeAllowanceToBeDeducted(payrollEntries, allowances) {
    if (!payrollEntries.length || !allowances.length) return {
        chargedToClient: 0,
        lessToBilling: 0,
        gross: 0
    };
    //console.log('computing allwoances', allowances)

    let chargedToClient = 0
    let lessToBilling = 0
    let gross = 0

    let allowancesFromStore = allowances.filter((allowance) => allowance.source === 'store' || allowance.source === 'group');

    payrollEntries.forEach((entry) => {
        let hourswork = entry.hours_work || 0

        //if allowance is for a specific user, it only applies to that user
        let allowancesForEmployee = allowances.filter((allowance) => allowanceAppliesToEmployee(allowance, entry));

        if (allowancesForEmployee.length > 0) {
            allowancesForEmployee.forEach((allowance) => {
                let allowanceAmount = (allowance.amount * hourswork) || 0;
                console.log(`applying specific allowance ${allowance.name} amount ${allowanceAmount} for employee ${entry.employee_id}`)

                if (allowance.type === 'billing')
                    lessToBilling += allowanceAmount
                else if (allowance.type === 'client')
                    chargedToClient += allowanceAmount
                else if (allowance.type === 'gross_billing')
                    gross += allowanceAmount
            })
        } else {

            allowancesFromStore.forEach((allowance) => {
                let allowanceAmount = (allowance.amount * hourswork) || 0;
                //console.log(`applying allowance ${allowance.name} amount ${allowanceAmount} for employee ${entry.employee_id}`)

                if (allowance.type === 'billing')
                    lessToBilling += allowanceAmount
                else if (allowance.type === 'client')
                    chargedToClient += allowanceAmount
                else if (allowance.type === 'gross_billing')
                    gross += allowanceAmount
            })
        }

    })



    /*
    allowances.forEach((allowance) => {
        let total = 0

        //allowance from store or group applies to all employees
        if (allowance.source === 'store' || allowance.source === 'group') {
            total = payrollEntries.reduce((acc, entry) => {
                let hourswork = entry.hours_work || 0
                return acc + (allowance.amount * hourswork)
            }, 0)
        }

        //if allowance is for a specific user, it only applies to that user
        if (allowance.user_id)
            total = (allowance.amount || 0)


        //add to respective types
        if (allowance.type === 'billing')
            lessToBilling += total
        else if (allowance.type === 'client')
            chargedToClient += total
        else if (allowance.type === 'gross_billing')
            gross += total
    })*/

    console.log('computed allowances to be deducted', {
        chargedToClient,
        lessToBilling,
        gross
    })

    return {
        chargedToClient,
        lessToBilling,
        gross
    }

}


//returns allowances and total amount
export function itemizeAndComputeAllowances(payrollEntries= [], allowances = [] ) {
    if(payrollEntries.length === 0 || allowances.length === 0)
        return []

   let allowancesFromStoreOrGroup = allowances.filter((allowance) => allowance.source === 'store' || allowance.source === 'group');


    payrollEntries.forEach((entry) => {
         let hourswork = entry.hours_work || 0
         let days_work = entry.days_work || 0

        //if allowance is for a specific user, it only applies to that user
        let allowancesForEmployee = allowances.filter((allowance) => allowanceAppliesToEmployee(allowance, entry));

        //allowance for employee comes first and disregard the allowances froms tore
         if (allowancesForEmployee.length > 0) {
            allowancesForEmployee.forEach((allowance, index) => {
                let allowanceAmount = (allowance.amount * hourswork) || 0;
                
                //edit allowance from allowance array
                allowance.amountTotal = (allowance.amountTotal || 0) + allowanceAmount;

                //edit the allowances array to increment the `totalAmount`
                let allowancesArrayIndex = allowances.findIndex((allowanceFromArray) => (allowanceFromArray._id === allowance._id))  
                if(allowancesArrayIndex > -1)
                    allowances[allowancesArrayIndex].totalAmount = (allowances[allowancesArrayIndex].totalAmount || 0) + allowanceAmount
            })
        } else {

            allowancesFromStoreOrGroup.forEach((allowance) => {
                let allowanceAmount = (allowance.amount * hourswork) || 0;
                //console.log(`applying allowance ${allowance.name} amount ${allowanceAmount} for employee ${entry.employee_id}`)

                let allowancesArrayIndex = allowances.findIndex((allowanceFromArray) => (allowanceFromArray._id === allowance._id))  
                if(allowancesArrayIndex > -1)
                    allowances[allowancesArrayIndex].totalAmount = (allowances[allowancesArrayIndex].totalAmount || 0) + allowanceAmount
            })
        }

    })

    return allowances
}

/**
 * Billing page itemized rows: merge personnel allowance lines into one "Personnel allowances" total.
 */
export function consolidatePersonnelAllowancesForBilling(itemizedAllowances = []) {
    if (!Array.isArray(itemizedAllowances) || itemizedAllowances.length === 0) return itemizedAllowances

    const personnel = []
    const storeGroup = []
    for (const row of itemizedAllowances) {
        const hasUser = row.user_id != null
        const src = row.source
        const isPersonnel = hasUser || src === 'personnel'
        if (isPersonnel) personnel.push(row)
        else storeGroup.push(row)
    }

    if (personnel.length === 0) return itemizedAllowances

    const totalAmount = personnel.reduce((s, r) => s + (Number(r.totalAmount) || 0), 0)
    if (totalAmount === 0) return storeGroup

    const pickType = (rows) => {
        const billing = rows.find((r) => (r.type || r.allowance_type) === 'billing')
        if (billing) return billing.type || billing.allowance_type || 'billing'
        const client = rows.find((r) => (r.type || r.allowance_type) === 'client')
        if (client) return client.type || client.allowance_type || 'client'
        const gross = rows.find((r) => (r.type || r.allowance_type) === 'gross_billing')
        if (gross) return gross.type || gross.allowance_type || 'gross_billing'
        const first = rows.find((r) => r.type || r.allowance_type)
        return (first && (first.type || first.allowance_type)) || 'billing'
    }

    const consolidated = {
        _id: '__billing_consolidated_personnel__',
        name: 'Personnel allowances',
        totalAmount,
        type: pickType(personnel),
        source: 'personnel',
    }

    return [...storeGroup, consolidated]
}

//the allowance is applied to the gross billing
 
//if the allowance is gross billing, we do nothing, already added to gross billing
//if the allowance is charged to client, we remove it from the gross billing and add to the total billing
//total billing is with tax
//if the allowance if less to billing, we remove it from the gross billing and apply to other deductions
export function applyAllowancesToBillingDetails(billingDetails = {}, allowances = {}) {
    if (!billingDetails) {
        console.log('will return')
        return billingDetails
    };

    let newBillingDetails = { ...billingDetails }

    let gross = allowances.gross || 0
    let chargedToClient = allowances.chargedToClient || 0
    let lessToBilling = allowances.lessToBilling || 0
    let manualOtherDeductions = getBillingManualOtherDeductions(newBillingDetails)


    if(chargedToClient > 0) {
        newBillingDetails.net_billing = (newBillingDetails.net_billing || 0) + chargedToClient

        //we deduct other deduction so it will count as rebate to client instead of deduction to billing
        manualOtherDeductions -= chargedToClient
    }

    if (lessToBilling > 0) {
        newBillingDetails.net_billing = (newBillingDetails.net_billing || 0) - lessToBilling
        manualOtherDeductions += lessToBilling
    }

    newBillingDetails.other_deductions = manualOtherDeductions


    /*
    if (chargedToClient > 0) {
        billingDetails.gross_billing -= chargedToClient
        billingDetails.total_billing += chargedToClient
    }

    if (lessToBilling > 0) {
        billingDetails.gross_billing -= lessToBilling
        billingDetails.other_deductions = (billingDetails.other_deductions || 0) + lessToBilling
    }

    billingDetails.net_billing = billingDetails.total_billing - billingDetails.salary_deduction - billingDetails.meal_allowance - (billingDetails.other_deductions || 0)
    */


    return newBillingDetails
}

export function addAllowancesToPayrollEntries(payrollEntries = [], allowances = [], options = {}) {
    const { consolidatePersonnelAllowances = false } = options
    if (!payrollEntries.length || !allowances.length) return payrollEntries;
    //console.log('applying allowances', allowances)

    let allowanceForStoreOrGroup = allowances.filter((allowance) => allowance.source === 'store' || allowance.source === 'group');

    console.log('allowance for store or group', allowanceForStoreOrGroup)
    return payrollEntries.map((entry) => {
        let hourswork = entry.hours_work || 0
        let days_work = entry.days_work || 0
        let allowancesForEmployee = allowances.filter((allowance) => allowanceAppliesToEmployee(allowance, entry));

        console.log('applying allowances for employee', entry.employee_id, allowancesForEmployee, days_work)

        //if there are specific allowances for the employee, use those instead
        if (allowancesForEmployee.length > 0) {
            let personnelTotal = 0;
            const breakdown = [];
            allowancesForEmployee.forEach((allowance) => {
                let allowanceAmount = (allowance.amount * hourswork) || 0;
                const name = allowance.name || 'Allowance'
                console.log(`applying allowance ${name} amount ${allowanceAmount} for employee ${entry.employee_id}`)
                if (!consolidatePersonnelAllowances) {
                    entry[name] = allowanceAmount;
                }
                personnelTotal += allowanceAmount;
                breakdown.push({ name, amount: allowanceAmount });
            });
            entry['Personnel allowances'] = personnelTotal;
            entry.personnel_allowance_breakdown = breakdown;
        } else {
            //apply allowances from store or group
       
            allowanceForStoreOrGroup.forEach((storeGroupAllowance) => {
                entry[`${storeGroupAllowance.name}`] = (storeGroupAllowance.amount * hourswork) || 0;
            });
        }

        return entry;
    });



    /**
     * Example allowance data
     */
 
}

export default {
    computeAllowanceToBeDeducted,
    applyAllowancesToBillingDetails,
    addAllowancesToPayrollEntries, 
    itemizeAndComputeAllowances,
    consolidatePersonnelAllowancesForBilling
}
